import { render, staticRenderFns } from "./ModalWithPicture.vue?vue&type=template&id=4d0ce6ed&scoped=true&"
import script from "./ModalWithPicture.vue?vue&type=script&lang=js&"
export * from "./ModalWithPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ce6ed",
  null
  
)

export default component.exports